import {Dropdown, Icon, Menu} from "antd";
import React from "react";

export default function (props) {

    console.log(props.submission)

    const notificationMenu = submission => (
        <Menu>
            <Menu.Item key="1"
                       onClick={props.showSendDialog.bind(this, submission.email, submission.submissionID, 'full')}>
                {/* <Icon type="user" /> */}
                Full Notification
            </Menu.Item>
            <Menu.Item key="2"
                       onClick={props.showSendDialog.bind(this, submission.email, submission.submissionID, 'minimal')}>
                {/* <Icon type="user" /> */}
                Minimal Notification
            </Menu.Item>
        </Menu>
    );

    if (props.submission.notified) {
        return <Dropdown.Button overlay={notificationMenu(props.submission)}
                                onClick={props.showSendDialog.bind(this, props.submission.email, props.submission.submissionID, 'full')}
                                type="primary" style={{background: "#52C41A", borderColor: "#52C41A"}}><Icon
            type="check"/> Notified</Dropdown.Button>
    } else {
        return <Dropdown.Button overlay={notificationMenu(props.submission)}
                                onClick={props.showSendDialog.bind(this, props.submission.email, props.submission.submissionID, 'full')}><Icon
            type="mail"/> Send</Dropdown.Button>
    }
}
